var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.89062C12.25 7.41043 12.0958 8.14429 11.7974 9.04913C11.5034 9.94067 11.0876 10.9448 10.6058 11.9864C9.64261 14.069 8.43772 16.2547 7.47997 17.909C7.03198 18.6828 5.96802 18.6828 5.52003 17.909C4.56228 16.2547 3.35739 14.069 2.39418 11.9864C1.91244 10.9448 1.49664 9.94067 1.20259 9.04913C0.90415 8.14429 0.75 7.41043 0.75 6.89062C0.75 3.45741 3.365 0.75 6.5 0.75C9.635 0.75 12.25 3.45741 12.25 6.89062Z",
    stroke: "#5CB1A3",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6,
    r: 1,
    fill: "#5CB1A3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.ebeb31b74bc347cfbeacf157ba2929b9.svg";
export { ForwardRef as ReactComponent };